
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overlays/qr",
      function () {
        return require("private-next-pages/overlays/qr.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/overlays/qr"])
      });
    }
  